import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-md space-y-3" }
const _hoisted_2 = {
  key: 0,
  class: "bg-yellow-900 border border-yellow-700 text-yellow-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_3 = { class: "block sm:inline" }
const _hoisted_4 = {
  key: 1,
  class: "bg-red-900 border border-red-700 text-red-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_5 = { class: "block sm:inline" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 2,
  class: "text-center text-sm text-red-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_PhoneInput = _resolveComponent("PhoneInput")!
  const _component_CityDropdown = _resolveComponent("CityDropdown")!
  const _component_FormCheckbox = _resolveComponent("FormCheckbox")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_TermsModal = _resolveComponent("TermsModal")!

  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-4",
    onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FormInput, {
        id: "first-name",
        name: "firstName",
        type: "text",
        label: "Ime",
        modelValue: _ctx.formData.firstName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.firstName) = $event)),
        placeholder: "Ime",
        error: _ctx.errors.firstName,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateField('firstName')))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_FormInput, {
        id: "last-name",
        name: "lastName",
        type: "text",
        label: "Prezime",
        modelValue: _ctx.formData.lastName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastName) = $event)),
        placeholder: "Prezime",
        error: _ctx.errors.lastName,
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateField('lastName')))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_FormInput, {
        id: "username",
        name: "username",
        type: "text",
        label: "Korisničko ime",
        modelValue: _ctx.formData.username,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.username) = $event)),
        placeholder: "Korisničko ime",
        required: "",
        error: _ctx.errors.username,
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateField('username'))),
        onInput: _ctx.debouncedCheckUsername
      }, null, 8, ["modelValue", "error", "onInput"]),
      _createVNode(_component_FormInput, {
        id: "email-address",
        name: "email",
        type: "email",
        label: "Email adresa",
        modelValue: _ctx.formData.email,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.email) = $event)),
        placeholder: "Email adresa",
        required: "",
        error: _ctx.errors.email,
        onBlur: _cache[7] || (_cache[7] = () => _ctx.validateField('email')),
        onInput: _ctx.debouncedCheckEmail
      }, null, 8, ["modelValue", "error", "onInput"]),
      _createVNode(_component_PhoneInput, {
        id: "phone-number",
        name: "phoneNumber",
        label: "Broj telefona",
        modelValue: _ctx.formData.phoneNumber,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.phoneNumber) = $event)),
        placeholder: "Broj telefona (OPCIONO)",
        error: _ctx.errors.phoneNumber,
        onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateField('phoneNumber')))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_FormInput, {
        id: "password",
        name: "password",
        type: "password",
        label: "Lozinka",
        modelValue: _ctx.formData.password,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.password) = $event)),
        placeholder: "Lozinka",
        required: "",
        error: _ctx.errors.password,
        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateField('password')))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_FormInput, {
        id: "confirm-password",
        name: "confirm-password",
        type: "password",
        label: "Potvrdi lozinku",
        modelValue: _ctx.formData.confirmPassword,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.confirmPassword) = $event)),
        placeholder: "Potvrdi lozinku",
        required: "",
        error: _ctx.errors.confirmPassword,
        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateField('confirmPassword')))
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_CityDropdown, {
        id: "city",
        modelValue: _ctx.formData.city,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.city) = $event)),
        label: "Grad",
        placeholder: "Izaberite grad",
        error: _ctx.errors.city,
        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateField('city')))
      }, null, 8, ["modelValue", "error"])
    ]),
    _createVNode(_component_FormCheckbox, {
      id: "terms-and-conditions",
      name: "termsAndConditions",
      modelValue: _ctx.formData.termsAccepted,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.termsAccepted) = $event)),
      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateField('termsAccepted')))
    }, {
      default: _withCtx(() => [
        _cache[21] || (_cache[21] = _createTextVNode(" Prihvatam ")),
        _createElementVNode("button", {
          type: "button",
          class: "text-indigo-400 hover:text-indigo-300 focus:outline-none",
          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.showTermsModal = true), ["prevent"]))
        }, " uslove korišćenja ")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.rateLimitWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.rateLimitWarning), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.serverError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.serverError), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FormButton, {
        loading: _ctx.loading,
        disabled: _ctx.registerBlocked,
        class: "w-full"
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [
          _createTextVNode(" Registruj se ")
        ])),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    (_ctx.cooldownActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Previše pokušaja registracije. Pokušajte ponovo za " + _toDisplayString(_ctx.cooldownTimeRemaining) + " sekundi. ", 1))
      : _createCommentVNode("", true),
    _createVNode(_component_TermsModal, {
      show: _ctx.showTermsModal,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showTermsModal = false)),
      onAccept: _ctx.acceptTerms
    }, null, 8, ["show", "onAccept"])
  ], 32))
}